import { render } from "./Tab2.vue?vue&type=template&id=40e7888e&bindings={\"photos\":\"setup\",\"takePhoto\":\"setup\",\"showActionSheet\":\"setup\",\"camera\":\"setup\",\"trash\":\"setup\",\"close\":\"setup\"}"
import script from "./Tab2.vue?vue&type=script&lang=ts"
export * from "./Tab2.vue?vue&type=script&lang=ts"
script.render = render

export default script